var map = {
	"./logo_dldebt.png": "9ed2",
	"./logo_rsv.png": "deb8",
	"./logo_ru.png": "a309",
	"./logo_ru_old.png": "0917",
	"./logo_ru_old2.png": "b042",
	"./logo_ua.png": "32fb",
	"./logo_ua_old.png": "b695",
	"./logo_ua_old2.png": "71d1",
	"./logo_ua_old3.png": "8d0f",
	"./master_card.png": "53d1",
	"./master_card_secure_code.gif": "cb64",
	"./mir.png": "5e24",
	"./rbk.png": "b1c9",
	"./rbk_money.jpg": "848b9",
	"./verified_visa.gif": "1545",
	"./visa.png": "073b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";